const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/users`;

export const saveUserData = async (userData) => {
  try {
    const response = await fetch(`${API_BASE_URL}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(userData),
    });

    const result = await response.json();

    if (response.ok) {
      return result;
    } else {
      throw new Error(result.message || "Failed to save user data");
    }
  } catch (error) {
    console.error("Error in saveUserData:", error);
    throw error;
  }
};

export const checkUserExists = async (clerkId) => {
  try {
    const response = await fetch(`${API_BASE_URL}?clerkId=${clerkId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const result = await response.json();
      return { exists: result.exists, role: result.role };
    } else {
      console.error("Error checking user existence", response.statusText);
      return { exists: false, role: null };
    }
  } catch (error) {
    console.error("Error occurred", error);
    return { exists: false, role: null };
  }
};

export const checkUserAuthorization = async (clerkId) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/authorization?clerkId=${clerkId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      const result = await response.json();
      return { authorization: result.authorization };
    } else {
      console.error("Error checking user authorization", response.statusText);
      return { authorization: null };
    }
  } catch (error) {
    console.error("error: ", error);
    return { authorization: null };
  }
};

export const checkUserAuthorizationAndRole = async (clerkId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/check`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${clerkId}`,
      },
    });
    if (response.ok) {
      const result = await response.json();
      return { authorization: result.authorization, role: result.role };
    } else {
      console.error(
        "Error fetching user authorization and role",
        response.statusText
      );
      return { authorization: null, role: null };
    }
  } catch (error) {
    console.error("Error fetching user authorization and role", error);
    return { authorization: null, role: null };
  }
};
